<template>
    <div class="teste-fontes">
            <h1>Power stones</h1>
            <h2>Power stones</h2>
            <h3>Power stones</h3>
            <h4>Power stones</h4>
            <h5>Power stones</h5>
            <h6>Power stones</h6>
            <p>Entre nesse universo</p>
            <span>Entre nesse universo</span>
        </div>
</template>
<script>
export default {
    name: "testeComponent"
}
</script>